import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowUpRight } from "lucide-react";

const FALLBACK = [
  { name: "Klipsch", description: "American horn-loaded engineering. Iconic cinema clarity." },
  { name: "KEF", description: "British reference — Uni-Q coaxial technology." },
];

export default function Brands() {
  const [brands, setBrands] = useState(FALLBACK);

  useEffect(() => {
    api.get("/brands").then((r) => { if (r.data && r.data.length) setBrands(r.data); }).catch(() => {});
  }, []);

  return (
    <div className="pt-32 pb-24 container-x" data-testid="brands-page">
      <div className="max-w-3xl mb-16">
        <div className="num-badge mb-4"><span>Premium Brands</span></div>
        <h1 className="font-display leading-[0.95] tracking-[-0.02em]" style={{ fontSize: "clamp(3rem, 6vw, 6rem)", fontWeight: 400 }}>
          Authorised. <em className="gold-text" style={{ fontWeight: 500 }}>Curated.</em>
        </h1>
        <p className="mt-6 max-w-xl leading-relaxed" style={{ color: "rgba(15,12,8,0.65)", fontFamily: "'Manrope', sans-serif" }}>
          Only the world's finest audio houses. Every piece we sell is genuine, warrantied and supported directly by the manufacturer.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {brands.map((b) => (
          <Link
            key={b.name}
            to={`/shop?q=${encodeURIComponent(b.name)}`}
            className="card-luxury brass-corners p-9 group flex flex-col justify-between min-h-[240px]"
            data-testid={`brand-detail-${b.name}`}
          >
            <div>
              {b.logo_url ? (
                <div className="mb-5 h-14 flex items-center">
                  <img
                    src={b.logo_url}
                    alt={b.name}
                    className="max-h-14 max-w-[180px] object-contain transition"
                    style={{ mixBlendMode: "multiply" }}
                  />
                </div>
              ) : (
                <div className="font-display text-[34px] leading-[1.05] tracking-[-0.015em] group-hover:brass-text transition mb-2" style={{ color: "var(--ink)", fontWeight: 500 }}>{b.name}</div>
              )}
              {b.description && (
                <p className="mt-2 text-sm leading-relaxed" style={{ color: "rgba(15,12,8,0.6)", fontFamily: "'Manrope', sans-serif" }}>{b.description}</p>
              )}
            </div>
            <div className="mt-7 text-[10px] uppercase tracking-[0.24em] inline-flex items-center gap-1.5" style={{ color: "rgba(15,12,8,0.5)", fontFamily: "'JetBrains Mono', monospace" }}>
              Shop {b.name} <ArrowUpRight className="w-3 h-3" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
